import { render } from "./email-list.vue?vue&type=template&id=329d15c3&scoped=true"
import script from "./email-list.vue?vue&type=script&lang=js"
export * from "./email-list.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-329d15c3"

export default script